<template>
    <div :class="['radiobutton-card', {'radiobutton-card--checked': carddata.status, 'radiobutton-card--error': error}]" @click="statusChanged()">
        <div class="radiobutton-card__icon">
            <img :src="icon || '/images/radio-checkbox-card.svg'" alt="Role icon">
        </div>
        <div class="radiobutton-card__title">
            {{ carddata.title }}
        </div>
        <div class="radiobutton-card__description" v-html="carddata.description"></div>
        <div :class="['radiobutton-card__radiobutton', {'radiobutton-card__radiobutton--checked': carddata.status}]">
            <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.173077 6.6C0.0576923 6.48 0 6.3 0 6.18C0 6.06 0.0576923 5.88 0.173077 5.76L0.980769 4.92C1.21154 4.68 1.55769 4.68 1.78846 4.92L1.84615 4.98L5.01923 8.52C5.13462 8.64 5.30769 8.64 5.42308 8.52L13.1538 0.18H13.2115C13.4423 -0.06 13.7885 -0.06 14.0192 0.18L14.8269 1.02C15.0577 1.26 15.0577 1.62 14.8269 1.86L5.59615 11.82C5.48077 11.94 5.36538 12 5.19231 12C5.01923 12 4.90385 11.94 4.78846 11.82L0.288462 6.78L0.173077 6.6Z" fill="white"/></svg>
        </div>
        <input type="radio" :name="name" :value="carddata.value" :checked="carddata.status" hidden/>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus';

    export default {
        props: ['card', 'name', 'icon', 'error'],

        data() {
            return {
                carddata: this.card,
            }
        },

        methods: {
            statusChanged() {
                this.carddata.status = !this.carddata.status;
                EventBus.$emit('radiobuttonStatusChanged', this.data);
            }
        },

        computed: {
            data() {
                return {'name': this.name, 'value': this.carddata.value, 'status': this.carddata.status};
            },
        },

        mounted() {
            EventBus.$emit('registerRadiobutton', this.data);
            EventBus.$on('radiobuttonStatusChanged', data => {
                if (data.name == this.name) {
                    if (this.carddata.status == true && this.carddata.value != data.value) {
                        this.carddata.status = false;
                    }
                }
            });
        }
    }
</script>
